import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * åç±»éç½®çéé¡¹
 */
@JsonObject
export class AttrOption {
  /**
   * éé¡¹Id
   */
  @JsonProperty('id', Number)
  id: number = undefined;

  /**
   * éé¡¹åºå·
   */
  @JsonProperty('index', Number)
  index: number = undefined;

  /**
   * éé¡¹æå­
   */
  @JsonProperty('name', String)
  name: string = undefined;

  constructor(name?: string) {
    this.name = name;
  }
}
